
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"File_upload","data-name":"File upload","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15307","data-name":"Rectangle 15307","width":"30","height":"30","fill":"none"}}),_c('g',{attrs:{"id":"Group_45520","data-name":"Group 45520"}},[_c('g',{attrs:{"id":"Group_45526","data-name":"Group 45526"}},[_c('path',{attrs:{"id":"Path_32717","data-name":"Path 32717","d":"M9.752 23.266a5.25 5.25 0 01-2.231-10 6 6 0 0111.56-2.725 3.75 3.75 0 013.991 2.559 3.772 3.772 0 01.138 1.739 4.5 4.5 0 011.99 5.531 4.53 4.53 0 01-4.2 2.9H9.752zM13.5 8.235a4.445 4.445 0 00-.861.084A4.505 4.505 0 009.081 13.6a.752.752 0 01-.5.857 3.75 3.75 0 001.173 7.312H21a3.02 3.02 0 002.8-1.931 3 3 0 00-1.733-3.876.749.749 0 01-.439-.949 2.276 2.276 0 00.017-1.443 2.251 2.251 0 00-2.836-1.444.747.747 0 01-.957-.523A4.512 4.512 0 0013.5 8.235m1.508 12.031a.75.75 0 01-.75-.75v-4.939L12.535 16.3a.75.75 0 01-1.06-1.06l3-3 .014-.014a.759.759 0 01.232-.149.741.741 0 01.259-.056h.05a.719.719 0 01.259.056.755.755 0 01.235.153l.006.005 3 3a.75.75 0 01-1.06 1.06l-1.72-1.719v4.939a.75.75 0 01-.75.75"}})])])])
          )
        }
      }
    